import once from 'lodash/once';
import React, { useEffect, useState } from 'react';
import cmsService from 'src/services/cms-service';

import styles from './CMSArticle.module.scss';

export type CMSArticleProps = {
    slug: string;
    substitutions?: { [key: string]: string };
    shouldShowTitle?: boolean;
    testId?: string;
    variant?: 'default' | 'prose';
};

const CMSArticle = (props: CMSArticleProps) => {
    const { slug, substitutions, shouldShowTitle = false, testId = 'slug-description', variant = 'default' } = props;

    const [article, setArticle] = useState<{ content: string; title: string } | null>(null);

    useEffect(() => {
        const fetchArticle = once(async () => {
            let { content, title } = (await cmsService.getArticleBySlug(slug)) || {};
            content = content || slug;
            title = title || '';
            content = substitutions ? cmsService.substituteArticlePlaceholders(content, substitutions) : content;

            setArticle({ content, title });
        });

        fetchArticle();
    }, [substitutions]);

    if (!article) {
        return null;
    }
    const contentClasses = [styles.content, variant === 'prose' && styles.prose].filter(Boolean).join(' ');
    const content = <div data-testid={testId} className={contentClasses} dangerouslySetInnerHTML={{ __html: article.content }} />;

    return (
        <div className='pb-2'>
            {shouldShowTitle && article?.title && <div className={styles.title}>{article.title}</div>}
            {content}
        </div>
    );
};

export default CMSArticle;
